"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MixPanelAssetType = void 0;
var MixPanelAssetType;
(function (MixPanelAssetType) {
    MixPanelAssetType["FONT_UPLOADED"] = "Font Uploaded";
    MixPanelAssetType["TERMS_UPDATED"] = "Terms Updated";
    MixPanelAssetType["FORM_PARAMETER_ADDED"] = "Form Parameter Added";
})(MixPanelAssetType || (exports.MixPanelAssetType = MixPanelAssetType = {}));
